import { useTranslation } from 'react-i18next'

import { Badge } from '@/components/ui/badge'

interface ActiveStatusBadgeProps {
  isActive: boolean
}

export const ActiveStatusBadge = ({ isActive }: ActiveStatusBadgeProps) => {
  const { t } = useTranslation(['organisation'])

  return (
    <Badge color={isActive ? 'green' : 'neutral'} size="small" variant="light">
      {isActive ? t('organisation:shared.status.active') : t('organisation:shared.status.inactive')}
    </Badge>
  )
}
